import { render, staticRenderFns } from "./Beneficio.vue?vue&type=template&id=486beada&scoped=true&"
import script from "./Beneficio.vue?vue&type=script&lang=js&"
export * from "./Beneficio.vue?vue&type=script&lang=js&"
import style0 from "./Beneficio.vue?vue&type=style&index=0&id=486beada&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486beada",
  null
  
)

export default component.exports